// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;You shall not be afraid of any terror by night,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;nor of the arrow that flies by day;<br> </p> </div></div>";
// Exports
module.exports = code;